import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ClientAssignment, ClientResponse, ServiceProviderResponse } from "../../profile-sdk";
import { cookieExists, extractCookieValue } from "../../utils/cookies";

export type LoggedInClientSliceStateType = ClientResponse | null;

const initialState: LoggedInClientSliceStateType = null;

export const loggedInClientSlice = createSlice({
  name: "logged in client",
  initialState: initialState as LoggedInClientSliceStateType,
  reducers: {
    setLoggedInClient: (state, action: PayloadAction<LoggedInClientSliceStateType>) => {
      return action.payload;
    },
    setCampusRestrictions: (state, action: PayloadAction<boolean>) => {
      state!.usesCampusRestrictions = action.payload;
    },
  },
});

// SELECTORS, used to read state
export const selectClientID = (state: RootState): string => {
  const loggedInUserClientIDCookie = cookieExists("loggedInUserClientID")
    ? extractCookieValue("loggedInUserClientID")
    : "";
  return loggedInUserClientIDCookie || state.loggedInClient?.id!;
};
export function selectClient(state: RootState): ClientResponse | null {
  return state.loggedInClient;
}

// If undefined, user hasn't completed onboarding flow
export function selectServiceProviderProfile(
  state: RootState,
): ServiceProviderResponse | undefined {
  const clientAssignment: ClientAssignment | undefined =
    state.userResponse?.clientAssignments?.find((ca) => {
      return ca.client?.id === state.loggedInClient?.id;
    });

  const res = clientAssignment?.serviceProviderProfile;

  return res;
}

// ACTIONS, used to execute logic
export const { setLoggedInClient, setCampusRestrictions } = loggedInClientSlice.actions;

export default loggedInClientSlice.reducer;
